import axios from "axios";
const getSiteInfoApi = async (callback, lang, baseURL, loading) => {
  loading(true);
  try {
    const response = await axios.get(`${baseURL}/website/siteInfo`, {
      headers: {
        Accept: "application/json",
        lang: lang,
      },
    });
    // console.log(data);
    callback(response.data.data);
    loading(false);
    return;
  } catch (error) {
    loading(false);
    throw new Error(error);
  }
};

export default getSiteInfoApi;
